require('./mortgageRequestInsurancesRelatedModal.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { fromJS } = require('immutable');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const { INSURANCE_MODAL_ICON } = require('constants/flagBasedFeatures');

// @ components
const BuildServicesItems = require('./mortgageRequestInsurancesRelatedModalServices');
const BuildPricingSection = require('./mortgageRequestInsurancesRelatedModalPricing');

// @ actions
const mortgageRequestInsurancesRelatedPricingActions = require('actions/mortgageRequest/mortgageRequestManagerInsuranceRelated');

class MortgageRequestInsurancesRelatedModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    componentWillMount() {
        const { mortgageRequestInsurancesPricingData } = this.props;
        mortgageRequestInsurancesPricingData();
    }

    handleToggleModal() {
        const { onHandleToggleModal } = this.props;
        onHandleToggleModal();
    }

    pricingSectionBackupValues() {
        const { mortgageRequestConditionsState } = this.props;
        const fee = mortgageRequestConditionsState.getIn(['conditions', 'cuotaMensual']);
        const tae = mortgageRequestConditionsState.getIn(['conditions', 'taeProd']);
        const fixedInterest = mortgageRequestConditionsState.getIn(['conditions', 'interes']);
        const pricingItem = {
            fixedInterest,
            fee,
            tae,
            homeInsurance: true
        }
        const pricingBackup = fromJS({
            insurancesRelatedPricing: [
                pricingItem,
                pricingItem
            ]
        })
        return pricingBackup;
    }

    render() {
        const {
            flagBasedFeatures,
            immInsurancesPricing,
            onHandleSaveMortgageWithInsuranceCondition,
            panelTitleFinalInfo,
            showModal,
        } = this.props;

        const isFetching = immInsurancesPricing.get('isFetchingPricing');
        const insurancePricing = !immInsurancesPricing.get('pricingError') ? immInsurancesPricing : this.pricingSectionBackupValues();
        const buildPricingSection = isFetching
            ? <LoadingSection />
            : <BuildPricingSection immInsurancesPricing={insurancePricing} typeMortgage={panelTitleFinalInfo.get('tipoProducto')} />;
        const modalSize = __CONTACT_CENTER__ ? 'extra-large' : 'large';
        const baseClass = 'mortgage-request-insurances-related-modal';
        const infoPricingClass = __CONTACT_CENTER__
            ? `${baseClass}__section-info-pricing-cc`
            : `${baseClass}__section-info-pricing`;
        const insuranceModalIconFlag = flagBasedFeatures.get(INSURANCE_MODAL_ICON);

        const modalContent = (
            <section className={`${baseClass}__section`}>
                <div className={`${baseClass}__section-info`}>
                    <div className={infoPricingClass}>
                        {buildPricingSection}
                    </div>
                    <FormattedText
                        className="text-center show"
                        value="mortgageRequestPanel-insurancesRelatedModalDescription"
                    />
                    <div className={`${baseClass}__section-info-services`}>
                        <h4 className={`${baseClass}__section-info-services-title`}>
                            <FormattedText value="mortgageRequestPanel-insurancesRelatedIncludedServices" />
                        </h4>

                        <div className={`${baseClass}__section-info-services-list`}>
                            <BuildServicesItems
                                insuranceModalIconFlag={insuranceModalIconFlag}
                            />
                        </div>
                    </div>
                </div>
            </section>
        );

        const modalFooter = (
            <h4 className={`${baseClass}__section-options-title`}>
                <FormattedText value="mortgageRequestPanel-insurancesRelatedModalQuestion" />
            </h4>
        );

        return (
            <OKModal
                content={modalContent}
                contentFooter={modalFooter}
                footerType="navigation"
                isOpen={showModal}
                onCloseCallback={this.handleToggleModal}
                onPrimaryButtonClick={onHandleSaveMortgageWithInsuranceCondition}
                onSecondaryButtonClick={this.handleToggleModal}
                primaryButtonText="mortgageRequestPanel-insurancesRelatedModalYesButton"
                secondaryButtonText="mortgageRequestPanel-insurancesRelatedNoLink"
                size={modalSize}
                title="mortgageRequestPanel-insurancesRelatedModalTitle"
            />
        );
    }
}

MortgageRequestInsurancesRelatedModal.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    immInsurancesPricing: PropTypes.object.isRequired,
    mortgageRequestConditionsState: PropTypes.object,
    mortgageRequestInsurancesPricingData: PropTypes.func.isRequired,
    onHandleSaveMortgageWithInsuranceCondition: PropTypes.func.isRequired,
    onHandleToggleModal: PropTypes.func.isRequired,
    panelTitleFinalInfo: PropTypes.object,
    showModal: PropTypes.bool.isRequired,
};

module.exports.MortgageRequestInsurancesRelatedModal = connect(
    state => ({
        immInsurancesPricing: state.mortgageRequestManagerInsuranceRelated,
        mortgageRequestConditionsState: state.mortgageRequestConditions,
        panelTitleFinalInfo: state.mortgageRequestPanelTitle,
    }), {
    mortgageRequestInsurancesPricingData: mortgageRequestInsurancesRelatedPricingActions.mortgageRequestInsurancesPricingData,
}
)(MortgageRequestInsurancesRelatedModal)
